export const LowKeySvg = () => {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30 37.5C32.5888 37.5 34.6875 35.4013 34.6875 32.8125C34.6875 30.2237 32.5888 28.125 30 28.125C27.4112 28.125 25.3125 30.2237 25.3125 32.8125C25.3125 35.4013 27.4112 37.5 30 37.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30 37.5V43.125"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M48.75 20.625H11.25C10.2145 20.625 9.375 21.4645 9.375 22.5V48.75C9.375 49.7855 10.2145 50.625 11.25 50.625H48.75C49.7855 50.625 50.625 49.7855 50.625 48.75V22.5C50.625 21.4645 49.7855 20.625 48.75 20.625Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.5625 20.625V12.1875C21.5625 9.94974 22.4514 7.80362 24.0338 6.22129C25.6161 4.63895 27.7622 3.75 30 3.75C32.2378 3.75 34.3839 4.63895 35.9662 6.22129C37.5486 7.80362 38.4375 9.94974 38.4375 12.1875V20.625"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
